import { drawXAxisMark } from '~/core/axis/x-axis/drawXAxis';
import { drawYAxisMarks } from '~/core/axis/y-axis/drawYAxis';
import { ChartAPIFunctionProps } from '~/types/create.types';
import { formatXAxisPoint } from '~/utils/dates';

export interface CrosshairOptions {
  hoveredPoint: {
    index: number;
    value: number;
    time: string;
  };
}

export const drawCrosshair = ({
  x,
  y,
  options,
  context,
  hoveredPoint,
}: ChartAPIFunctionProps<CrosshairOptions>) => {
  const dashWidth = 6;
  const dashOffset = 6;
  const x1 = x.xScale(hoveredPoint.index);
  const y1 = y.yScale(hoveredPoint.value);

  context.save();
  context.lineWidth = 1;
  context.strokeStyle = options.colors.border.default;

  //draw vertical/horizontal lines
  context.setLineDash([dashWidth, dashOffset]);
  context.beginPath();

  context.moveTo(x1, 0);
  context.lineTo(x1, options.height - options.gutters.x);
  context.moveTo(0, y1);
  context.lineTo(options.width - options.gutters.y, y1);
  context.stroke();
  context.closePath();
  context.setLineDash([0, 0]);

  context.strokeStyle = options.colors.white;
  context.fillStyle = options.colors.primary;
  context.beginPath();
  context.arc(x1, y1, 3, 0, 2 * Math.PI);
  context.fill();
  context.stroke();

  drawYAxisMarks({
    context,
    options,
    rectColor: options.colors.surface.default,
    textColor: options.colors.white,
    yScale: y.yScale,
    data: [{ value: hoveredPoint.value, time: hoveredPoint.time }],
  });

  drawXAxisMark({
    context,
    rectColor: options.colors.surface.default,
    textColor: options.colors.white,
    x: x1,
    y: options.height - options.gutters.x + 1,
    label: formatXAxisPoint(new Date(hoveredPoint.time)),
  });

  context.restore();
};
